<template>
  <div class="height1">
    <bread></bread>
    <div class="center-content">
      <div class="iq-card-body">
        <div class="table-top">
          <div class="iq-search-bar">
            <el-form :model="searchForm" :inline="true">
              <el-form-item label="">
                <el-input
                  v-model="searchForm.keyWord"
                  type="text"
                  size="small"
                  placeholder="药师名称/手机号"
                  @keyup.enter.native="Search"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="Search()"
                  >搜索</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
        <el-table
          :data="tableData"
          stripe
          style="width: 100%"
          :header-cell-style="{ background: '#F5F7FC' }"
          height="calc(100% - 80px)"
        >
          <el-table-column
            type="index"
            label="编号"
            width="50"
          ></el-table-column>
          <el-table-column
            prop="auditPharmacistName"
            label="药师名称"
          ></el-table-column>
          <el-table-column
            prop="auditPharmacistPhone"
            label="药师手机号"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="count"
            label="订单数量"
            align="center"
          ></el-table-column>
          <el-table-column label="操作" align="center" width="150px">
            <template slot-scope="scope">
              <span class="primary optionBtn" @click="prviewBtn(scope.row)"
                >详情</span
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="changePage"
          :page-size="pageSize"
          :current-page="pageIndex"
          :total="dataTotal"
          layout="total, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="订单列表" :visible.sync="detailDialog" width="70%">
      <div class="iq-search-bar" style="margin-bottom: 10px">
        <el-form :model="searchDetailForm" :inline="true">
          <el-form-item label="">
            <el-input
              v-model="searchDetailForm.keyWord"
              type="text"
              size="small"
              placeholder="患者姓名/订单号"
              @keyup.enter.native="SearchDetail"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="SearchDetail()"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <el-table
        :data="detailTableData"
        stripe
        style="width: 100%"
        height="450px"
        :header-cell-style="{ background: '#F5F7FC' }"
      >
        <el-table-column
          prop="orderNum"
          label="订单编号"
          width="230"
        ></el-table-column>
        <el-table-column prop="patientName" label="患者" align="center">
          <template slot-scope="scope">
            {{ scope.row.patientName ? scope.row.patientName : "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="diagnoseResult" label="诊断" align="center">
          <template slot-scope="scope">
            {{ scope.row.diagnoseResult ? scope.row.diagnoseResult : "-" }}
          </template>
        </el-table-column>

        <el-table-column prop="totalPayMoney" label="总金额(元)" align="center">
          <template slot-scope="scope">
            {{
              scope.row.totalPayMoney
                ? scope.row.totalPayMoney.toFixed(2)
                : "0.00"
            }}
          </template>
        </el-table-column>
        <el-table-column prop="doctorName" label="开方医生" align="center">
          <template slot-scope="scope">
            {{ scope.row.doctorName ? scope.row.doctorName : "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="auditUserName" label="审方医生" align="center">
        </el-table-column>
        <!-- <el-table-column
          prop="paySuccessTime"
          label="收费日期"
          align="center"
          width="160"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.paySuccessTime | timefilters }}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
            <span class="info optionBtn" @click="toOrderInfo(scope.row)"
              >详情</span
            >
          </template>
        </el-table-column> -->
      </el-table>
      <el-pagination
        @current-change="changeDetailPage"
        :page-size="pageSize2"
        :current-page="pageIndex2"
        :total="dataTotal2"
        layout="total, prev, pager, next, jumper"
      ></el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import { Outpatient } from "@/components/DrugDomain/Outpatient.js";
export default {
  data() {
    var outpatient = new Outpatient(this.TokenClient, this.Services.Drug);
    return {
      OutpatientDomain: outpatient,
      tableData: [],
      pageIndex: 1,
      dataTotal: 0,
      pageSize: 15,
      searchForm: {
        keyWord: "",
      },
      // 详情相关
      selectedPharmacistId: null,
      detailDialog: false,
      detailTableData: [],
      pageIndex2: 1,
      dataTotal2: 0,
      pageSize2: 10,
      searchDetailForm: {
        keyWord: "",
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      var _this = this;
      _this.tableData = [];

      _this.OutpatientDomain.PharmacistAuditStatistics(
        _this.searchForm.keyWord,
        _this.pageIndex,
        _this.pageSize,
        function (data) {
          _this.tableData = data.data.results;
          _this.pageIndex = data.data.pageIndex;
          _this.pageSize = data.data.pageSize;
          _this.dataTotal = data.data.dataTotal;
        },
        function (err) {
          console.log(err);
        }
      );
    },
    Search() {
      this.pageIndex = 1;
      this.getList();
    },
    changePage(pageIndex) {
      this.pageIndex = pageIndex;
      this.getList();
    },
    prviewBtn(row) {
      this.selectedPharmacistId = row.auditPharmacistId;
      this.detailDialog = true;
      this.pageIndex2 = 1;
      this.searchDetailForm.keyWord = "";
      this.getOrderDetail();
    },
    getOrderDetail() {
      var _this = this;
      _this.detailTableData = [];
      _this.OutpatientDomain.GetPharmacistOrderList(
        _this.selectedPharmacistId,
        _this.searchDetailForm.keyWord,
        _this.pageIndex2,
        function (data) {
          _this.detailTableData = data.data.results;
          _this.pageIndex2 = data.data.pageIndex;
          _this.pageSize2 = data.data.pageSize;
          _this.dataTotal2 = data.data.dataTotal;
        },
        function (err) {
          console.log(err);
        }
      );
    },
    SearchDetail() {
      this.pageIndex2 = 1;
      this.getOrderDetail();
    },
    changeDetailPage(pageIndex) {
      this.pageIndex2 = pageIndex;
      this.getOrderDetail();
    },
    toOrderInfo(item) {
      this.$router.push({
        path: "/Outpatient/OrderInfo",
        query: {
          type: 1, //已收费
          orderId: item.id,
        },
      });
    },
  },
};
</script>

<style scoped>
.optionBtn {
  cursor: pointer;
  margin: 0 5px;
  color: #409eff;
}
</style>
